import React from 'react';
import PropTypes from 'prop-types';
import {Button as B, Image} from '@learningblocks/storybook-components';
import ButtonIcon from '@learningblocks/exp-constants/lib/Images/mc_settings_button_icon.svg';
import InvalidIcon from '@learningblocks/exp-constants/lib/Images/mc_settings_button_invalid.svg';

import './style.scss';

const TRIGGER_INTERVAL = 200;

export function Button(props) {
  const classNamePrefix = props.disabled
    ? 'mc_settings_invalidBtn'
    : 'mc_settings_button';
  const className = props.rotate
    ? `${classNamePrefix}--rotate`
    : `${classNamePrefix}`;

  const [isMouseDown, setMouseState] = React.useState(false);
  const [counter, setCounter] = React.useState(0);

  React.useEffect(() => {
    if (isMouseDown) {
      setTimeout(() => {
        props.onClick();
        setCounter(counter + 1);
      }, TRIGGER_INTERVAL);
    }
  }, [isMouseDown, counter]);

  const onMouseDown = () => {
    setMouseState(true);
  };
  const onMouseUp = () => {
    setMouseState(false);
  };

  return (
    <B className={className} onMouseDown={onMouseDown} onMouseUp={onMouseUp} onKeyPress={props.onKeyPress}>
      {!props.disabled && (
        <Image
          className='mc_settings_button_icon'
          src={ButtonIcon}
          ariaLabel={props.altText1}
          alt={props.altText}
        />
      )}
      {props.disabled && (
        <Image
          className='mc_settings_button_icon'
          src={InvalidIcon}
        />
      )}
    </B>
  );
}

Button.propTypes = {
  /**
   * specifies orientation of button icon
   */
  rotate: PropTypes.bool,
  /**
   * callback for button onClick
   */
  onClick: PropTypes.func,
  /**
   * specifies if the button is disabled
   */
  disabled: PropTypes.bool,
};

Button.defaultProps = {};
